import {useViewportSize} from '@react-aria/utils';

export function useOverlayViewport(): Record<string, string> {
  const {width, height} = useViewportSize();
  return {
    '--msm-viewport-height': `${height}px`,
    '--msm-viewport-width': `${width}px`,
  };
}
